import React, { Fragment } from 'react';
import { bool, func, object } from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import styles from './AccountProfileBankInfo.scss';
import EditBankInfoForm from './components/EditBankInfoForm';

import {
  getBankEditOpenStatus,
  openEditPanel,
  closeEditPanel,
  getBankInfoData,
} from '@dragonfruit/redux/bank';
const mapStateToProps = state => ({
  bankEditOpenStatus: getBankEditOpenStatus(state),
  bankInfoData: getBankInfoData(state),
});

const ACCOUNT_DIGITS_TO_SHOW = 5;

function AccountProfileBankInfo({
  t,
  bankEditOpenStatus,
  closeEditPanel,
  openEditPanel,
  bankInfoData,
}) {
  const onToggleBank = () => {
    return bankEditOpenStatus ? closeEditPanel() : openEditPanel();
  };
  const getBankDescription = () => {
    const { accountNumber } = bankInfoData;
    const editHint = t('account.bank.editingDescription');
    return !!accountNumber
      ? `＊＊＊＊＊＊＊＊＊＊${accountNumber.slice(-ACCOUNT_DIGITS_TO_SHOW)}`
      : editHint;
  };

  return (
    <div className={styles.input}>
      <div className={styles.fieldContainer}>
        <p className={styles.field}>{t('account.bank.title')}</p>
        <div className={styles.reset}>
          {!bankEditOpenStatus && (
            <Fragment>
              <p className={styles.value}>{getBankDescription()}</p>
              <h6 className={styles.linkButton} onClick={onToggleBank}>
                {t('account.bank.edit')}
              </h6>
            </Fragment>
          )}
        </div>

        {bankEditOpenStatus && (
          <div className={styles.resetFormPadded}>
            <div className={styles.header}>
              <p className={styles.field}>
                {t('account.bank.editingDescription')}
              </p>
              <div className={styles.linkButton} onClick={onToggleBank}>
                {t('account.bank.cancel')}
              </div>
            </div>
            <EditBankInfoForm />
          </div>
        )}
      </div>
    </div>
  );
}
AccountProfileBankInfo.propTypes = {
  bankEditOpenStatus: bool.isRequired,
  bankInfoData: object.isRequired,
  closeEditPanel: func.isRequired,
  openEditPanel: func.isRequired,
  t: func.isRequired,
};

export default connect(mapStateToProps, {
  closeEditPanel,
  openEditPanel,
})(translate('account')(AccountProfileBankInfo));



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/AccountProfileBankInfo/AccountProfileBankInfo.jsx